import { Typography } from "@mui/material";

import HNSColors from "../../../../../ui library/HNSColors";
import CustomAddressSearchBar from "../Fields/CustomAddressSearchBar";

export default function SearchOverlay() {
  return (
    <div className="absolute left-0 right-0 top-0 p-4">
      <div className="flex w-full flex-col gap-2 rounded-[8px] bg-white px-4 py-6 shadow-md">
        <Typography style={{ color: HNSColors.primary[500], fontWeight: 600, fontSize: 20 }}>
          Search Closest Provider
        </Typography>
        <CustomAddressSearchBar />
      </div>
    </div>
  );
}
